import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class GuestIdInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (
      request.url.includes(environment.api) &&
      !/^(\/assets|assets)/i.test(request.url) &&
      localStorage.getItem('guestId') &&
      localStorage.getItem('guestId') !== 'preview'
    ) {
      return next.handle(
        request.clone({
          headers: request.headers.set('guestid', localStorage.getItem('guestId') as string),
        }),
      );
    }
    return next.handle(request);
  }
}
